import React from "react";
import { useSelector } from "react-redux";
import { Icon } from '@flashtalking/rhombus-react';

import { CREATE, EDIT } from "./helpers";

import './SelfApproval.css';

export default function SelfApproval({ mode, value }){
	const isInternal = useSelector(state => state.you.isInternal);

	if(!isInternal || mode === CREATE){ return null; }

	return (
		<p className="self-approval">
			<span className="label">Self-Approval: </span>
			{!value && (<span className="icon red"><Icon name="far fa-times-circle" /></span>)}
			{value && (<span className="icon green"><Icon name="far fa-check-circle" /></span>)}
		</p>
	);
}

SelfApproval.displayName = "SelfApproval";
SelfApproval.defaultProps = {
	mode:EDIT,
};
